import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: 2em 0;

	.headline {
		font-size: 1.1em;
		font-weight: 700;
	}

	.public-page-company-site-section-company-block-title {
		.title {
			margin: 0;
			padding: 0;
		}
	}

	.list {
		ul,ol {
            list-style-image: none;
        }
		.list-element {
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.element-content {
				ol {
					margin: 0;
					margin-block: 0;
					padding-left: 1em;
				}
			}

			.icon {
				max-width: 100%;
				margin-right: 1em;
			}
		}
	}

	@media all and (max-width: ${variables.mobileL}) {
		.public-page-company-site-section-company-block-title {
			padding: 0;
		}

		.list {
			flex-flow: column nowrap;

			.list-element {
				width: 100%;

				.element-content {
					width: 100%;
				}
			}
		}
	}
`;
